import React, { useEffect, useRef } from "react";

import { Container, ThemeUICSSObject } from "theme-ui";

import { BaseProp } from "../@types/base-types";

type ModalProps = {
  onModalOverlayClick?: () => void;
  modalSx?: ThemeUICSSObject;
} & BaseProp;

export const Modal: React.FC<ModalProps> = ({ children, onModalOverlayClick, modalSx }) => {
  const overlayRef = useRef<HTMLDivElement>(null);
  const [mounted, setMounted] = React.useState(false);

  useEffect(() => {
    setTimeout(() => setMounted(true), 100);
  }, []);

  return (
    <Container
      ref={overlayRef}
      onClick={e => {
        if (e.target === overlayRef.current) {
          // https://github.com/AstridDAO/frontend/issues/561
          // onModalOverlayClick && onModalOverlayClick();
        }
      }}
      variant="modalOverlay"
    >
      <Container
        variant="cards.modal"
        sx={{
          bg: mounted ? "W100" : "transparent",
          ...modalSx
        }}
      >
        {children}
      </Container>
    </Container>
  );
};
